import { instance } from '../instances';

export interface ImportExcelPayload {
  path: '/import-location-provider' | '/import-service-monitoring' | '/import-provider' | '/import-patient' | '/import-diagnosis-population';
  file: FormData;
}

export const importExcel = (payload: ImportExcelPayload): Promise<any> => {
  return instance.post(payload.path, payload.file,
    { headers: { 'Content-Type': 'multipart/form-data' } }).then((n) => n.data);
};
